import { render, staticRenderFns } from "./publicaciones.vue?vue&type=template&id=4da2f04e&scoped=true&"
import script from "./publicaciones.vue?vue&type=script&lang=ts&"
export * from "./publicaciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2f04e",
  null
  
)

export default component.exports